<template>
  <div>
       <!--====== PRELOADER PART START ======-->

    <!-- <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>        
        <div class="layer layer-three"><span class="overlay"></span></div>        
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->

    <sidebar-home-one :sidebar="sidebar" @toggleSidebar="toggleSidebar"  :menuItems="navs" />
    <!--====== OFFCANVAS MENU PART ENDS ======-->
   
    <!--====== PART START ======-->
    
    <header-contact @toggleSidebar="toggleSidebar" :menuItems="navs"/>
    
    <!--====== PART ENDS ======-->

    <!--====== APPIE PAGE TITLE PART START ======-->
    
    <!-- reference by news -->
    <title-area/>
    
    <!--====== APPIE PAGE TITLE PART ENDS ======-->

        <!-- Contact Start -->
        <contact-inputs/>
        <!-- Contact End -->

        <!-- Gamps Start -->
        <div class="bisylms-map">
            <iframe src="https://maps.google.com/maps?width=720&amp;height=600&amp;hl=en&amp;coord=39.966528,-75.158284&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland+(My%20Business%20Name)&amp;ie=UTF8&amp;t=p&amp;z=16&amp;iwloc=B&amp;output=embed"  ></iframe>
        </div>
        <!-- Gamps Start -->

    <!--====== APPIE FOOTER PART START ======-->
    
    <footer-home-one/>
    
    <!--====== APPIE FOOTER PART ENDS ======-->


    <!--====== APPIE BACK TO TOP PART ENDS ======-->
    <div class="back-to-top">
        <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->

  </div>
</template>

<script>
import FooterHomeOne from '../HomeOne/FooterHomeOne.vue'
import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'
import TitleArea from '../News/TitleArea.vue'
import ContactInputs from './ContactInputs.vue'
import HeaderContact from './HeaderContact.vue'
export default {
	components: { SidebarHomeOne, HeaderContact, TitleArea, ContactInputs, FooterHomeOne },
        data(){
        return{
            sidebar:false,
              navs:[
            {
                name:'home',
                childrens:[
                    {
                        name:'Home 1',
                        path:'/'
                    },
                    {
                        name:'Home 2',
                        path:'/home-two'
                    },
                    {
                        name:'Home 3',
                        path:'/home-three'
                    },
                    {
                        name:'Home 4',
                        path:'/home-four'
                    },
                    {
                        name:'Home 5',
                        path:'/home-five'
                    },
                    {
                        name:'Home 6',
                        path:'/home-six'
                    },
                    {
                        name:'Home 7',
                        path:'/home-seven'
                    },
                    {
                        name:'Home 8',
                        path:'/home-eight'
                    },
                ],
            },
            {
                name:'service',
                path:'/service-details'
            },
                {
                name:'pages',
                    childrens:[
                    {
                        name:'About us',
                        path:'/about-us'
                    },
                    {
                        name:'Error',
                        path:'/error'
                    }
                ],
            },
            {
                name:'news',
                    childrens:[
                    {
                        name:'News',
                        path:'/news'
                    },
                    {
                        name:'Single news',
                        path:'/single-news'
                    },
                ],
            },
            {
                name:'contact',
                    path:'/contact'
            }
            ]
        }
    },
     mounted() {
        document.addEventListener('scroll', this.topToBottom)
    },
    methods:{
        topToBottom(){
        const result = document.querySelector('.back-to-top')
           if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight ) {
                result.style.display = "block";
            } else {
                result.style.display = "none";
            }
        },
         toggleSidebar(){
           this.sidebar = !this.sidebar
        },  
    }

}
</script>

<style>

</style>